import { http } from "../http-common";

const FetchImportList = query => {
  if (query?.searchquery) {
    return http.get(`importLogHeader/${query?.entityName}?pageNumber=${query?.pageNumber}&pageSize=${query?.size}&startDate=${query?.startDate}&endDate=${query?.endDate}&keyword=${query?.searchquery}`);
  } else {
    return http.get(`importLogHeader/${query?.entityName}?pageNumber=${query?.pageNumber}&pageSize=${query?.size}&startDate=${query?.startDate}&endDate=${query?.endDate}`);
  }
};

const FetchLogsList = query => {
  if(query?.searchQuery){
    return http.get(`import-contract?pageNumber=${query?.pageNumber}&size=${query?.size}&importContractId=${query?.headerID}&status=${query?.searchQuery}`);
  } else {
    return http.get(`import-contract?pageNumber=${query?.pageNumber}&size=${query?.size}&importContractId=${query?.headerID}`);

  }
};

const FetchLogDetails = query => {
return http.get(`/import-contract/contract-details/${query?.headerID}/`);
};
const UploadFile = query => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return http.post(`/importLogHeader/${query?.entityName}?usuername=${query?.username}&importDate=${query?.importDate}&importTime=${query?.importTime}&comments=${query?.comment}`, query?.file, config);
};



const DownloadFile = query => {
  const config = {
    headers: {
      'Content-Type': 'application/octet-stream',
      'Accept': 'application/octet-stream'
    }
  }
  return http.get(`/importLogHeader/template/${query?.name}?isTemplate=${query?.isTemplate}`, config);
};
const DownloadExcelFile = query => {
  const config = {
    responseType:'blob',
    headers: {
      'accept': 'application/octet-stream',
    }
  }
  return http.get(`/importLogHeader/template/${query?.name}?isTemplate=${query?.isTemplate}`, config);
};
const ExportAll = query => {
  
  return http.get(`/importLogHeader/exportFile/${query?.ilHeaderId}`);
};

////////Hierarchy  Methods Start ////////////////
const ImportHierarchyProcessStart = id => {
  return http.post(`/hierarchy-import/start-process/${id}`);
};

const GetImportHierarchyLogProgress = id => {
  return http.get(`/hierarchy-import/progress/${id}`);
};
const ImportHierarchyLogCancel = id => {
  return http.post(`/hierarchy-import/cancel/${id?.id}`);
};
////////Hierarchy  Methods END ////////////////

//////////Farmer start////////
const UploadStartProcess = id => {
  return http.post(`/farmer-import/start-process/${id}`);
};
const UploadProgress = id => {
  return http.get(`/farmer-import/progress/${id}`);
};
const UploadCancel = id => {
  return http.post(`/farmer-import/cancel/${id?.id}`);
};
//////////Farmer end////////

//////////Contract start////////
const ImportContractProcessStart = id => {
  return http.post(`/import-contract/transfer-data` ,`{"import-id":"${id}"}`);
};
const GetImportContractLogProgress = id => {
  return http.get(`/import-contract/progress/${id}`);
};
const ImportContractLogCancel = id => {
  return http.post(`/import-contract/cancel/${id?.id}`);
};
//////////Contract end////////

const fetchImportStatusAPI = (query) => {
  return http.get(`/${query?.entityName}/status/${query?.IlHeaderId}`);
};

const ImportService = {
  FetchImportList,
  UploadFile,
  UploadStartProcess,
  UploadProgress,
  UploadCancel,
  DownloadFile,
  ExportAll,
  ImportHierarchyProcessStart,
  GetImportHierarchyLogProgress,
  ImportHierarchyLogCancel,
  ImportContractProcessStart,
  GetImportContractLogProgress,
  ImportContractLogCancel,
  FetchLogsList,
  FetchLogDetails,
  fetchImportStatusAPI,
  DownloadExcelFile
};

export default ImportService;

